import { Controller } from '@hotwired/stimulus'

import { setUrlParam } from '../../utils/uriUtils'
import { preventFieldEdit } from './utils/formUtils'

// Connects to data-controller="site-task-measurements--index-single"
export default class extends Controller {
  static targets = ['draw', 'measurements', 'drawingFields', 'drawingId', 'drawingTitle', 'measurementsFields', 'unit',
    'measurementTotal', 'isDrawing']
  static values = { siteId: String }

  connect() {
    this.element.addEventListener('updateDrawing', this.updateDrawing.bind(this))

    if (this.isDrawingTarget.value === 'true') {
      this.setDrawingMode()
    } else {
      this.setMeasurementsMode()
    }
  }

  disconnect() {
    this.element.removeEventListener('updateDrawing', this.updateDrawing.bind(this))
  }

  setDrawingMode() {
    this.isDrawingTarget.value = 'true'
    this.setActive(this.drawTarget)
    this.setInactive(this.measurementsTarget)
    this.drawingFieldsTargets.forEach(t => t.classList.remove('d-none'))
    this.measurementsFieldsTargets.forEach(t => t.classList.add('d-none'))
    preventFieldEdit(this.measurementTotalTarget)
    const samePartsField = this.element.querySelector('[id^="measure_same_parts_"]')
    if (samePartsField) {
      samePartsField.closest('div').classList.add('d-none')
    }
  }

  setMeasurementsMode() {
    this.isDrawingTarget.value = 'false'
    this.setInactive(this.drawTarget)
    this.setActive(this.measurementsTarget)
    this.drawingFieldsTargets.forEach(t => t.classList.add('d-none'))
    this.measurementsFieldsTargets.forEach(t => t.classList.remove('d-none'))
    const samePartsField = this.element.querySelector('[id^="measure_same_parts_"]')
    if (samePartsField) {
      samePartsField.closest('div').classList.remove('d-none')
    }
  }

  updateDrawing(event) {
    const { drawingId, drawingTitle, unit, total } = event.detail
    this.drawingIdTarget.value = drawingId
    this.drawingTitleTarget.href = setUrlParam(this.drawingTitleTarget.href, 'drawing_id', drawingId)
    this.drawingTitleTarget.innerHTML = drawingTitle

    // ------------------------------------------------------------
    // Q: Why `unit` and `hidden unit`? A: <select> does not support `readonly` so we have a hidden field to submit the value.
    // Update both the select and the hidden field for :unit
    this.unitTarget.value = unit
    this.unitTarget.dispatchEvent(new Event('change'))
    // Also update the hidden field for :unit (which follows the select in the DOM)
    const hiddenUnitField = this.unitTarget.parentElement.querySelector('input[type="hidden"][name$="[unit]"]')
    hiddenUnitField.value = unit
    // ------------------------------------------------------------

    // this.measurementTotalTarget.removeAttribute('disabled')
    this.measurementTotalTarget.value = total
    // this.measurementTotalTarget.setAttribute('disabled', false)
    window.dispatchEvent(new CustomEvent('measurementTotalChange', {
      detail: { unit, total, drawing_id: drawingId, element: this.element }
    }))
  }

  setActive(target) {
    target.classList.remove('btn-outline-secondary')
    target.classList.add('btn-secondary', 'active')
  }

  setInactive(target) {
    target.classList.remove('btn-secondary', 'active')
    target.classList.add('btn-outline-secondary')
  }

  openDrawingModal(event) {
    event.preventDefault()
    const link = event.target.closest('a') || event.target
    const drawingId = this.drawingIdTarget.value
    const url = setUrlParam(link.href, 'drawing_id', drawingId)
    fetch(url, {
      headers: { Accept: 'text/vnd.turbo-stream.html; charset=utf-8' }
    })
      .then(response => response.text())
      .then(html => Turbo.renderStreamMessage(html))
  }

  cleanInvalidInputs() {
    document.querySelectorAll('.is-invalid').forEach(i => i.classList.remove('is-invalid'))
    document.querySelectorAll('.invalid-feedback').forEach(i => i.remove())
  }
}
